/**
 * @generated SignedSource<<1a37d0cc5e344e6feebb2f8aebd1e276>>
 * @relayHash 5afdecfedd0657e37dbd0d163456bb31
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 5afdecfedd0657e37dbd0d163456bb31

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "documentsConvertion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DocumentsConvertionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DocumentsConvertionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "5afdecfedd0657e37dbd0d163456bb31",
    "metadata": {},
    "name": "DocumentsConvertionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "24fc10056bbded968fc4573aef48e585";

export default node;
